var React = require('react');

function Deco1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Fill 2"),React.createElement("g",{"id":"/-features-/-website-builder","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"website-builder","transform":"translate(-242, -2515)","fill":"#FF9671"},React.createElement("g",{"id":"Fill-2","transform":"translate(242, 2515)"},React.createElement("polygon",{"id":"Fill-1","points":"59.0029774 0 59.0029774 13.2559816 39.3353182 0 39.3353182 13.2559816 19.6676591 0 19.6676591 13.2559816 0 0 0 31 19.6676591 17.7440184 19.6676591 31 39.3353182 17.7440184 39.3353182 31 59.0029774 17.7440184 59.0029774 31 82 15.500156"}))))]);
}

Deco1.defaultProps = {"width":"82px","height":"31px","viewBox":"0 0 82 31","version":"1.1"};

module.exports = Deco1;

Deco1.default = Deco1;
